var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAus = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_19569_32213)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 8C16 12.4183 12.4183 16 8 16C3.58175 16 0 12.4183 0 8C0 8.00187 8 0.00090625 8 0C12.4183 0 16 3.58175 16 8Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.99939 0C7.99895 0 7.99848 0.000666667 7.99805 0.000666667L7.99939 0Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.97852 7.99992H7.99992C7.99992 7.99267 7.99992 7.98573 7.99992 7.97852C7.9928 7.98567 7.98567 7.9928 7.97852 7.99992Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 4.17391C8 2.76625 8 1.84384 8 0H7.99866C3.581 0.00071875 0 3.58212 0 7.99997H4.17391V5.64959L6.52428 7.99997H7.97862C7.98578 7.99284 7.99291 7.98572 8.00003 7.97856C8.00003 7.43959 8.00003 6.95869 8.00003 6.52431L5.64962 4.17391H8Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.04684 1.04395C2.79562 1.75641 1.75544 2.7966 1.04297 4.04782V8.00048H3.12994V3.13095V3.13091H7.9995C7.9995 2.4727 7.9995 1.84563 7.9995 1.04395H4.04684Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.99989 7.01707L5.15761 4.17482H4.17383C4.17383 4.17479 4.17383 4.17482 4.17383 4.17482L7.99986 8.00085H7.99989C7.99989 8.00085 7.99989 7.32257 7.99989 7.01707Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.82486 9.3916L5.26392 10.3097L6.25539 10.0805L5.81139 10.9962L6.6087 11.6285L5.61598 11.8522L5.61877 12.8699L4.82486 12.2332L4.03098 12.8699L4.03377 11.8522L3.04102 11.6285L3.83836 10.9962L3.3943 10.0805L4.38583 10.3097L4.82486 9.3916Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9778 11.1309L12.1974 11.5899L12.6931 11.4753L12.4711 11.9331L12.8698 12.2493L12.3734 12.3612L12.3748 12.87L11.9778 12.5516L11.5809 12.87L11.5823 12.3612L11.0859 12.2493L11.4846 11.9331L11.2626 11.4753L11.7583 11.5899L11.9778 11.1309Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.93491 6.26074L10.1544 6.7198L10.6502 6.60518L10.4282 7.06302L10.8268 7.37918L10.3305 7.49105L10.3318 7.99987L9.93491 7.68152L9.53797 7.99987L9.53931 7.49105L9.04297 7.37918L9.44163 7.06302L9.21963 6.60518L9.71537 6.7198L9.93491 6.26074Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9778 3.47852L12.1974 3.93758L12.6931 3.82298L12.4711 4.28083L12.8698 4.59695L12.3734 4.70886L12.3748 5.21767L11.9778 4.89933L11.5809 5.21767L11.5823 4.70886L11.0859 4.59695L11.4846 4.28083L11.2626 3.82298L11.7583 3.93758L11.9778 3.47852Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.7611 5.56543L13.9806 6.02449L14.4763 5.90987L14.2543 6.36771L14.653 6.68387L14.1566 6.79577L14.158 7.30455L13.7611 6.98624L13.3641 7.30455L13.3655 6.79577L12.8691 6.68387L13.2678 6.36771L13.0458 5.90987L13.5415 6.02449L13.7611 5.56543Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.4854 8L12.658 8.53144H13.2168L12.7647 8.85991L12.9375 9.39131L12.4854 9.06287L12.0333 9.39131L12.206 8.85991L11.7539 8.53144H12.3127L12.4854 8Z",
  fill: "#F0F0F0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_19569_32213"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAus);
export { ForwardRef as ReactComponent };